import { render, staticRenderFns } from "./change.vue?vue&type=template&id=2cb6a09c&scoped=true"
import script from "./change.vue?vue&type=script&lang=js"
export * from "./change.vue?vue&type=script&lang=js"
import style0 from "./change.vue?vue&type=style&index=0&id=2cb6a09c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6a09c",
  null
  
)

export default component.exports